<mat-card #mat_card>
  <mat-card-content>
    <form #form="ngForm" class="sensor-form" *ngIf="showServers">
      <div class="sensor-input">
        <mat-form-field appearance="outline">
          <mat-label>Edge Gateway</mat-label>
          <input matInput name="edgegateway" [(ngModel)]="edgeGateway" required>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>WebSocket</mat-label>
          <input matInput name="websocket" [(ngModel)]="ws" required>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>ESP-NOW Gateway</mat-label>
          <input matInput name="espnowgateway" [(ngModel)]="espNowGateway" required>
        </mat-form-field>
        <button mat-raised-button type="button" class="device-form-button" (click)="saveServers()" [disabled]="!form.valid" cdkFocusInitial>Update</button>
      </div>
    </form>  

    

    <mat-icon class="cached" (click)="refresh()">cached</mat-icon>
    <mat-icon class="cached" (click)="toggleServers()">fingerprint</mat-icon>
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8 home-hub-table">
      <!--- Note that these columns can be defined in any order.
            The actual rendered columns are set as a property on the row definition" -->

      <!-- Name Column -->
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef> Name </th>
        <td mat-cell *matCellDef="let element" (click)="showDialog(element.mac)" class="hand-pointer"> {{element.name}} </td>
      </ng-container>

      <!-- Status Column -->
      <ng-container matColumnDef="moisture">
        <th mat-header-cell *matHeaderCellDef> Moisture </th>
        <td mat-cell *matCellDef="let element">
          {{ element.displayMoisture || element.moisture }}
        </td>
      </ng-container>

      <!-- Last Updated Column -->
      <ng-container matColumnDef="lastUpdate">
        <th mat-header-cell *matHeaderCellDef> Last Update </th>
        <td mat-cell *matCellDef="let element" class="date-font"> {{element.lastUpdate}} </td>
      </ng-container>

      <ng-container matColumnDef="sensorType">
        <th mat-header-cell *matHeaderCellDef> Sensor Type </th>
        <td mat-cell *matCellDef="let element">
          <mat-form-field appearance="fill">
            <mat-select [(value)]="element.sensorType" (selectionChange)="onSensorTypeChange(element, $event.value)">
              <mat-option *ngFor="let type of sensorTypes" [value]="type">
                {{ type }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </td>
      </ng-container>


      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef>Status</th>
        <td mat-cell *matCellDef="let element">
        </td>
        
      </ng-container>

      


      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      <!--(click)="showDialog(row.mac)" class="hand-pointer"
      </tr>-->
    </table>
  </mat-card-content>  
</mat-card>